import { InvoiceDownloadNotice } from "../customNotice/botNotice/invoiceDownloadNotice";
import { InvoiceErrorNotice } from "../customNotice/botNotice/InvoiceErrorNotice";
import { TrackingNotice } from "../customNotice/botNotice/trackingNotice";
import { ConfigurationManager } from "../utils/configurationManager";
export class InvoiceElement {
    constructor(widget, container) {
        this.INVOICE_URL = "/kara/gucci/microfrontend-meina1-invoices";
        this.ASSET_BASE_PATH = "https://cdn11.a1.net/assetsup/free/genesys-chatui/last/";
        this.CSS = "widgetResources/css/gucci-x-fresh-x-cbot.css";
        this.invoice = container;
        this.contractConfig = this.createContractConfig(this.invoice);
        this.INVOICE_URL = ConfigurationManager.setValueIfExists(widget.configuration, 'invoiceSettings.url', this.INVOICE_URL);
        this.ASSET_BASE_PATH = ConfigurationManager.setValueIfExists(widget.configuration, 'assetBase', this.ASSET_BASE_PATH);
        this.CSS = ConfigurationManager.setValueIfExists(widget.configuration, 'gucciCommonFreshBot', this.CSS);
        this.widget = widget;
        this.loadWidget();
    }
    static getInvoiceElement(node) {
        if (node.classList && node.classList.contains('cbot-invoice')) {
            return node;
        }
        else if (node.hasChildNodes()) {
            return $(node).find('.cbot-invoice').get(0);
        }
        return undefined;
    }
    createContractConfig(node) {
        let contractConfig = {};
        contractConfig["ban"] = node.attributes.getNamedItem('data-ban').value;
        contractConfig["ben"] = node.attributes.getNamedItem('data-ben').value;
        contractConfig["vk"] = node.attributes.getNamedItem('data-vk').value;
        return contractConfig;
    }
    createConfig() {
        let config = {
            appConfig: {
                contractConfig: this.contractConfig,
            },
            proxyPaths: {
                __baseUrl: this.INVOICE_URL,
                bff: this.INVOICE_URL + "/api",
            },
            restProxyPaths: {
                __baseUrl: this.INVOICE_URL,
                bff: this.INVOICE_URL + "/api",
            },
        };
        return config;
    }
    loadWidget() {
        try {
            this.loadCss();
            let config = this.createConfig();
            const scriptElem = document.createElement('script');
            scriptElem.src = this.INVOICE_URL + "/index.js";
            scriptElem.addEventListener('load', () => {
                var clientServices = {
                    messageBus: {
                        subscribe: function (topic, handler) {
                        },
                        unsubscribe: function (topic, handler) {
                        },
                        publish: (topic, data) => {
                            if (topic.toLowerCase().includes("error")) {
                                this.handleError();
                            }
                        }
                    }
                };
                try {
                    this.trackDownloadButton();
                    this.trackInvoiceWidgetShown();
                    window["startupMeinA1Invoices"](this.invoice, config, clientServices);
                }
                catch (e) {
                    this.handleError();
                }
            });
            scriptElem.addEventListener("error", () => {
                this.handleError();
            });
            document.head.appendChild(scriptElem);
        }
        catch (e) {
            this.handleError();
        }
    }
    handleError() {
        console.log("Invoice: Error");
        this.invoice.innerHTML = "";
        this.widget.sendCustomNotice(new InvoiceErrorNotice());
    }
    trackInvoiceWidgetShown() {
        const targetNode = this.invoice;
        const config = { childList: true, subtree: true };
        const callback = (mutationsList, observer) => {
            const doesWidgetExist = $(this.invoice).find('div>div>div');
            if (doesWidgetExist.length) {
                this.widget.sendCustomNotice(new TrackingNotice("chat", "Gucci_Bill_Show", "Gucci_Bill_Show"));
                observer.disconnect();
            }
        };
        const observer = new MutationObserver(callback);
        observer.observe(targetNode, config);
    }
    trackDownloadButton() {
        const targetNode = this.invoice;
        const config = { childList: true, subtree: true };
        const callback = (mutationsList, observer) => {
            const downloadButton = $(this.invoice).find('button').filter(function () {
                return /^\s*normal\s*$/.test($(this).attr("class"));
            });
            if (downloadButton.attr('cbot-download') === undefined) {
                downloadButton.on('click', () => {
                    this.widget.sendCustomNotice(new InvoiceDownloadNotice());
                    this.widget.sendCustomNotice(new TrackingNotice("chat", "Gucci_Bill_Click", "Gucci_Bill_Click"));
                });
                downloadButton.attr('cbot-download', 'true');
            }
        };
        const observer = new MutationObserver(callback);
        observer.observe(targetNode, config);
    }
    loadCss() {
        var fileref = document.createElement("link");
        fileref.rel = "stylesheet";
        fileref.type = "text/css";
        fileref.href = this.ASSET_BASE_PATH + this.CSS;
        document.getElementsByTagName("head")[0].appendChild(fileref);
    }
}
